app = angular.module('harriApp');


app.directive('hMediaViewer', ['$compile', '$state', '$stateParams', 'mediaViewerData', '$timeout', '$location', 'deviceChecker', '$filter', 'dependenciesLoaderService', 'SharingWidgetService',
    function ($compile, $state, $stateParams, mediaViewerData, $timeout, $location, deviceChecker, $filter, dependenciesLoaderService, SharingWidgetService) {
        //h-media-viewer="media-img" media-status="AMS.applicants.media_viewer" gallery-images="gallery_images" gallery-videos
        return {
            restrict: 'A',
            scope: {
                'mediaStatus': '@',
                'hMediaViewer': '@',
                'application_id': '=?',
                'hMediaStaySameState': '=',
                'autostart': '<',
                'mute': '<',
            },
            link: function (scope, element, attr) {

                dependenciesLoaderService.load([{type: "library", path: "../ext_libs/jwplayer/jwplayer.js"}])
                    .then(function () {

                // selector group
                var groupName = '.' + attr['hMediaViewer'],

                // share html
                    shareHTML = $compile('<h-sharing-widget ></h-sharing-widget>')(scope);

                // gallery images
                scope.galleryImages = [];

                // gallery videos
                scope.galleryVideos = [];

                var emailTooltip = $filter("translate")("Email");
                var tweetTooltip = $filter("translate")("Tweet");

                var linkedInTooltip = 'Linked In';
                var facebookTooltip = 'Facebook';
                var pinterestTooltip = 'Pinterest';

                var nextTooltip = $filter("translate")("Next");
                var prevTooltip = $filter("translate")("Previous");

                var configuration = {
                    beforeLoad: function () {
                        // $('body').addClass('hideFromScree')
                        // if its youtube
                        var $element = this.element;

                        if ($element.data('href')) {
                            var videoObj = MediaUtils.parseVideoURL($element.data('href'));

                            if (videoObj.type == 'youtube') {
                                this.href = '//www.youtube.com/embed/' + videoObj.id + '/?autoplay=1&rel=0';
                            }
                            else if (videoObj.type == 'vimeo') {
                                this.href = '//player.vimeo.com/video/' + videoObj.id + '/?title=0&byline=0&portrait=0&autoplay=1';
                            }

                            else if ($element.hasClass('harri-video')) {
                                // Do nothing
                            }
                        }

                    },
                  afterShow: function () {


                    var $element = this.element;
                    var $fancy = $('#fancybox-wrap');


                    var $titleDiv = $fancy.find('.media-viewer-title');
                    var $descDiv = $fancy.find('.media-viewer-desc');
                    var title = $element.attr('title');
                    var desc = $element.attr('title');
                      var hideSocialSharing = $element.attr('hide-social-sharing');
                      if (!hideSocialSharing) {
                          $timeout(function () {
                              $(".media-share a").each(function (index, element) {
                                  var url = SharingWidgetService.getSocialMediaUrl(element.id, window.location.href);
                                  if (url) {
                                      element.href = url;
                                  }
                              });
                          }, 100);
                      } else {
                          $(".media-share").css('display', 'none');
                      }

                    if( title != '' ){
                      $titleDiv.show();
                      $titleDiv.html($element.attr('title'));
                    }
                    else{
                      $titleDiv.hide();
                    }

                    if( desc != '' ){
                      $descDiv.show();
                      $descDiv.html($element.data('desc'));
                    }
                    else{
                      $descDiv.hide();
                    }

                      var x = {
                          "path": $element.attr("data-href"),
                          "harriMedia": $element.hasClass("harri-media"),
                          'image': $element.attr("data-img-src"),
                          "type": "application_video",
                          "uuid": $element.attr("id"),
                          "video_domain": $element.attr("domain"),
                          "transcoded_file": $element.attr("transcoded-file"),
                          "mute": scope.mute,
                          "autostart": scope.autostart
                      };

                    if ($element.hasClass('harri-video')) {
                      var setupHarriVideo = function() {
                        $fancy.find('.fancybox-inner').html('<div class="harri-vplayer"><div id="hosted-media-video" ></div></div>');
                          x.media_uuid = x.uuid;
                        hVideoPlayer(x, 'hosted-media-video');
                        $timeout(function(){
                          $('.harri-vplayer').addClass('harri-vplayer-width');
                        }, 1000);
                      }

                      $(window).resize(function() {
                        if ($.find(".harri-vplayer")) {
                          setupHarriVideo();
                        }
                      });

                      setupHarriVideo();
                    }

                    $('body').addClass("noScroll");


                    if ($element.attr('id') && scope.mediaStatus) {
                      $state.go(scope.mediaStatus, { img_id: $element.attr('id')});
                    }
                    /** setTimeout(function(){
                            $('body').removeClass('hideFromScree')
                        },100); */
                  },
                  padding: 15,
                  tpl: {
                    wrap: '<div class="fancybox-wrap" tabIndex="-1" id="fancybox-wrap">\
                                <div class="fancybox-skin">\
                                    <div class="fancybox-outer">\
                                        <div class="fancybox-inner"></div>\
                                    </div>\
                                    <div class="sep-15"></div> <div class="media-viewer-title open-sans-condensed"> </div> \
                                    <div class="media-viewer-desc"> </div> <div class="sep-15"></div>' +
                                    '<div class="media-share sharing-widget share-widget-toolbox">\
                                        <a class="blue" title="' + emailTooltip + '" href="mailto:?&body='+window.location.href+'">\
                                        <i class="fa fa-fw fa-envelope-square"></i>\
                                        </a>\
                                        <a class="pinterest-btn" target="_blank" id="pinterest" title="' + pinterestTooltip + '">\
                                        <i class="fa fa-fw fa-pinterest-square"></i>\
                                        </a>\
                                        <a class="twitter-btn" target="_blank" id="twitter" title="' + tweetTooltip + '">\
                                        <div class="twitter-square">\
                                        <?xml version="1.0" encoding="UTF-8"?>\
                                            <svg width="595.9px" height="557.73px" viewBox="0 0 448 448" version="1.1" xmlns="http://www.w3.org/2000/svg"\
                                                 xmlns:xlink="http://www.w3.org/1999/xlink" class="primary-size">\
                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\
                                                    <g id="Group" fill="#888888" fill-rule="nonzero" class="primary-fill">\
                                                        <polygon id="Path"\
                                                                 points="238.980799 216.350774 339.797229 360.554197 298.422037 360.554197 216.15361 242.883912 216.15361 242.87661 204.075501 225.602869 107.972747 88.1358761 149.347938 88.1358761 226.902689 199.077033"></polygon>\
                                                        <path\
                                                            d="M399.592632,0 L48.4073676,0 C21.6734148,0 0,21.6734148 0,48.4073676 L0,399.592632 C0,426.326585 21.6734148,448 48.4073676,448 L399.592632,448 C426.326585,448 448,426.326585 448,399.592632 L448,48.4073676 C448,21.6734148 426.326585,0 399.592632,0 L399.592632,0 Z M285.748786,379.912763 L202.498191,258.751948 L98.2679055,379.912763 L71.3294866,379.912763 L190.536919,241.350416 L71.3294866,67.8572127 L162.251214,67.8572127 L241.083879,182.588297 L339.782624,67.8572127 L366.721043,67.8572127 L253.048802,199.99348 L253.0415,199.99348 L376.670513,379.912763 L285.748786,379.912763 Z"\
                                                            id="Shape"></path>\
                                                    </g>\
                                                </g>\
                                            </svg>\
                                        </div>\
                                        </a>\
                                        <a class="facebook-btn"  target="_blank" id="facebook" title="' + facebookTooltip + '">\
                                        <i class="fa fa-fw fa-facebook-square"></i>\
                                        </a>\
                                        <a class="linkedin-btn" target="_blank" id="linkedIn" title="' + linkedInTooltip + '">\
                                        <i class="fa fa-fw fa-linkedin-square"></i>\
                                        </a>\
                                     </div>\
                                    <div class="sep-15"></div>\
                                 </div>\
                             </div>',
                    next: '<a title="' + nextTooltip + '" class="fancybox-nav fancybox-next" style="top: 40%; height: 20%; width: 30%;" href="javascript:;"><span></span></a>',
                    prev: '<a title="' + prevTooltip + '" class="fancybox-nav fancybox-prev" style="top: 40%; height: 20%; width: 30%;" href="javascript:;"><span></span></a>'
                  },
                  afterClose: function () {
                    // var url = $state.href('^');
                    // history.pushState(null, null, url);
                    if(!scope.hMediaStaySameState){
                        try {
                            if ($state.current.name.indexOf(".media") > 0) {
                                $state.go("^");
                            }
                        }
                        catch (e) {
                          console.warn(e);
                        }
                    }

                    $('body').removeClass('noScroll');
                  },
                  openEffect:'none',
                  closeEffect:'none',
                  nextEffect:'none',
                  prevEffect:'none',
                  helpers: {
                    overlay: {
                      locked: false
                    }
                  }

                };

                if (scope.autostart) {
                    configuration.tpl['iframe'] = '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen allow="autoplay; fullscreen" src=""></iframe>';
                }
                if (deviceChecker.isMobile()) {
                  configuration.padding = 0;
                  configuration.margin = 15;
                }

                element.find(groupName).fancybox(configuration);


                if ($stateParams['img_id']) {
                    element.find('#' + $stateParams['img_id']).trigger('click');
                }


                scope.galleryImages = [];
                scope.galleryVideos = [];

                if (scope.application_id) {
                  mediaViewerData.mediaGallery(scope.application_id).then(function (resp) {
                    var gallery = resp.data.data.gallery;
                    _.each(gallery, function (item) {
                      switch (item.type) {
                        case 'gallery_images':
                          scope.galleryImages.push(item);
                          break;

                        case 'gallery_videos':
                          if (/youtube.com/.test(item.path)) {
                            item.type = 'youtube';
                          }
                          else if (/vimeo.com/.test(item.path)) {
                            item.type = 'vimeo';
                          }
                          else {
                            // item.type = 'video-link';
                          }
                          scope.galleryVideos.push(item);
                          break;
                      }
                    });
                  }, function (err) {
                    console.log('err', err);
                  });
                }
                    });
            }
        };
    }]);
